import React, { useContext } from 'react';
import { Typography, Theme, Link } from '@mui/material';
import { authContext } from 'helpers/services';
import theme from 'assets';


const Error401 = () => {
  let authService = useContext(authContext);

  return (
    <div style={{
      marginTop: 150,
      padding: theme.spacing(3),
      display: 'flex',
      alignItems: 'center',
      flexDirection: 'column'
    }}>
      <Typography
        align="center"
        variant="h1"
      >
        401: Sorry, we're unable to authenticate you
      </Typography>
      <Typography
        align="center"
        variant="subtitle2"
      >
        Your account is not enabled in our system or you did not choose the right login option.&nbsp;
        <Link onClick={() => authService.signOut()}>Please logout and try again</Link>
      </Typography>
      <img
        alt="Internal server error"
        src="/images/errors/401.svg"
        style={{
          display: 'inline-block',
          marginTop: 50,
          maxWidth: '100%',
          width: 560
        }}
      />
    </div >
  );
};

export default Error401;
